import React from 'react';
import {toast} from 'react-toastify';
import ToastMessage from '../components/common/toast-message';
import irelandApi from '../irelandApi';

export const getOutletRewardAllocations = (incentivesOutletsId) => dispatch => {
  dispatch({
    type: 'GET_OUTLET_REWARD_ALLOCATIONS_PENDING',
    payload: []
  });
  return irelandApi
    .get(`/api/admin/staff_reward_allocations/${incentivesOutletsId}/by_incentives_outlet`)
    .then(response => {
      dispatch({
        type: 'GET_OUTLET_REWARD_ALLOCATIONS_FULFILLED',
        payLoad: response.data
      });
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const saveOutletRewardAllocations = (incentiveId, customerNumber, outletrewardAllocations) => dispatch => {
  return irelandApi.patch(`/api/admin/staff_reward_allocations/save`, {
    incentive_id: incentiveId,
    customer_number: customerNumber,
    staff_reward_allocations: outletrewardAllocations
  })
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Outlet reward allocations has been successfully saved"/>);
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="Error during saving outlet reward allocations"/>);
                   })
};



// WEBPACK FOOTER //
// ./src/actions/outlet-reward-allocations.js